import { Link } from "react-router-dom";
import { Gift, Menu, X, ShoppingCart, Truck, LayoutDashboard } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";


export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="glass-header sticky top-0 z-50 border-b border-gray-100" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img src="/logo.png" alt="BVGLink Biznis" className="h-12 object-contain" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-4">
            
            <Link
              to="/"
              className="text-gray-700 hover:text-[#FF9900] font-medium transition-colors"
              data-testid="nav-home"
            >
              Akèy
            </Link>
            <Link
              to="/?meru=true"
              className="text-gray-700 hover:text-[#FF9900] font-medium transition-colors"
              data-testid="nav-meru"
            >
              Rechaj Meru
            </Link>
            <Link
              to="/marketplace"
              className="text-gray-700 hover:text-[#FF9900] font-medium transition-colors"
              data-testid="nav-marketplace"
            >
              Marketplace
            </Link>

            {localStorage.getItem("seller_token") ? (
              <Link
                to="/seller/dashboard"
                className="text-gray-700 hover:text-[#FF9900] font-bold text-[10px] uppercase tracking-widest transition-colors border-l pl-4 border-gray-200"
                data-testid="nav-seller-dashboard"
              >
                Dashboard Machann
              </Link>
            ) : (
              <Link
                to="/seller/login"
                className="text-gray-700 hover:text-[#FF9900] font-bold text-[10px] uppercase tracking-widest transition-colors border-l pl-4 border-gray-200"
                data-testid="nav-seller-login"
              >
                Konekte Machann
              </Link>
            )}
            {localStorage.getItem("driver_token") ? (
              <Link
                to="/driver/dashboard"
                className="text-gray-700 hover:text-[#FF9900] font-bold text-xs uppercase tracking-widest transition-colors flex items-center gap-2"
              >
                <Truck className="w-4 h-4 text-[#FF9900]" /> Dashboard Chofè
              </Link>
            ) : (
                <Link
                to="/driver/login"
                className="text-gray-700 hover:text-[#FF9900] font-bold text-xs uppercase tracking-widest transition-colors flex items-center gap-2"
              >
                <Truck className="w-4 h-4 text-[#FF9900]" /> Vin yon Chofè
              </Link>
            )}


            {localStorage.getItem("buyer_token") ? (
              <Link
                to="/linkamazon/dashboard"
                className="flex items-center gap-2 bg-[#232F3E] text-white px-4 py-2 rounded-lg hover:bg-[#37475A] transition-colors font-bold"
                data-testid="nav-dashboard"
              >
                Kont Mwen
              </Link>
            ) : (
              <Link
                to="/linkamazon"
                className="flex items-center gap-2 bg-[#FF9900] text-white px-4 py-2 rounded-lg hover:bg-[#E88B00] transition-colors font-bold"
                data-testid="nav-login"
              >
                Konekte
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100 fade-in">
            <nav className="flex flex-col gap-4">
              <Link
                to="/"
                className="text-gray-700 hover:text-[#FF9900] font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-home"
              >
                Akèy
              </Link>
              <Link
                to="/?meru=true"
                className="text-gray-700 hover:text-[#FF9900] font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-meru"
              >
                Rechaj Meru
              </Link>
              <Link
                to="/marketplace"
                className="text-gray-700 hover:text-[#FF9900] font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="mobile-nav-marketplace"
              >
                Marketplace
              </Link>

              {localStorage.getItem("seller_token") ? (
                <Link
                  to="/seller/dashboard"
                  className="text-gray-700 hover:text-[#FF9900] font-bold py-2 uppercase text-[10px] tracking-widest"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-nav-seller-dashboard"
                >
                  Dashboard Machann
                </Link>
              ) : (
                <Link
                  to="/seller/login"
                  className="text-gray-700 hover:text-[#FF9900] font-bold py-2 uppercase text-[10px] tracking-widest"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-nav-seller-login"
                >
                  Konekte kòm Machann
                </Link>
              )}
              {localStorage.getItem("driver_token") ? (
                 <Link
                 to="/driver/dashboard"
                 className="text-gray-700 hover:text-[#FF9900] font-bold py-3 uppercase text-xs tracking-widest flex items-center gap-3"
                 onClick={() => setMobileMenuOpen(false)}
               >
                 <Truck className="w-5 h-5 text-[#FF9900]" /> Dashboard Chofè
               </Link>
              ) : (
                <Link
                to="/driver/login"
                className="text-gray-700 hover:text-[#FF9900] font-bold py-3 uppercase text-xs tracking-widest flex items-center gap-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Truck className="w-5 h-5 text-[#FF9900]" /> Vin yon Chofè
              </Link>
              )}

              {localStorage.getItem("buyer_token") ? (
                <Link
                  to="/linkamazon/dashboard"
                  className="flex items-center gap-2 bg-[#232F3E] text-white px-4 py-3 rounded-xl font-bold mt-2 shadow-lg"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-nav-dashboard"
                >
                  Kont Mwen
                </Link>
              ) : (
                <Link
                  to="/linkamazon"
                  className="flex items-center gap-2 bg-[#FF9900] text-white px-4 py-3 rounded-xl font-bold mt-2 shadow-lg"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-nav-login"
                >
                  Konekte
                </Link>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
